/**
 * @see https://developer.android.com/reference/android/widget/LinearLayout#attr_android:gravity
 */
export var BannerAdPosition;
(function (BannerAdPosition) {
    /**
     * Positions the banner at the top center of the screen.
     */
    BannerAdPosition["TOP_CENTER"] = "TOP_CENTER";
    /**
     * Positions the banner at the center of the screen.
     */
    BannerAdPosition["CENTER"] = "CENTER";
    /**
     * Positions the banner at the bottom center of the screen.
     */
    BannerAdPosition["BOTTOM_CENTER"] = "BOTTOM_CENTER";
})(BannerAdPosition || (BannerAdPosition = {}));
//# sourceMappingURL=banner-ad-position.enum.js.map